import { render } from "./AppReleaseNotesDialog.vue?vue&type=template&id=3f90665c&scoped=true&ts=true"
import script from "./AppReleaseNotesDialog.vue?vue&type=script&lang=ts"
export * from "./AppReleaseNotesDialog.vue?vue&type=script&lang=ts"

import "./AppReleaseNotesDialog.vue?vue&type=style&index=0&id=3f90665c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f90665c"]])

export default __exports__